import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Container, Row, Col, Modal } from 'react-bootstrap';
import ShopLogo from '../../assets/images/shop_logo_web.png';
import Icons from '../../constants/Icons';
import BuyPoints from '../shop/BuyPoints';
import { useApplicationParams } from '../../context';

const Header = ({ loadingPage }) => {
  const { t } = useTranslation();

  const { userToken, isIos } = useApplicationParams();

  const [menuVisible, setMenuVisible] = useState(false);
  const [buyPointsVisible, setBuyPointsVisible] = useState(false);

  const navigate = useNavigate();

  const handleMenuClick = () => {
    setMenuVisible((menuVisible) => !menuVisible);
  };

  const handleOrdersClick = () => {
    navigate(userToken ? `/shop/orders` : `/shop/orders/?navigation=authentication`);
  };

  const handleCustomerSupportClick = () => {
    navigate(`/shop/customer-support`);
  };

  useEffect(() => {
    if (!loadingPage) {
      setTimeout(() => {
        setBuyPointsVisible(true);
      }, 2500);
    }
  }, [loadingPage]);

  const originPath = window.location.origin;

  return (
    <section className="header-section">
      <Container>
        <Row className="align-items-center">
          <Col>
            <a className="text-center" href={`/shop?userToken=${userToken}`} target="_self">
              <img src={ShopLogo} className="logo-img" alt="" />
            </a>
          </Col>
          <Col className="d-flex align-items-center justify-content-end">
            {buyPointsVisible && (
              <BuyPoints url={`/shop?navigation=buyPointsDrawer&userToken=${userToken}`} />
            )}
            <div className="menu-div">
              <img src={Icons.menu} className="menu-img" alt="" onClick={handleMenuClick} />
            </div>
          </Col>
        </Row>
      </Container>
      <Modal show={menuVisible} onHide={handleMenuClick} className="menu-modal">
        <Modal.Body>
          <div style={{ paddingBottom: isIos ? '140px' : '30px' }} className="menu-body">
            {userToken ? (
              <div className="menu-row" onClick={handleOrdersClick}>
                <img src={Icons.orders} className="menu-item-img" alt="" />
                <span className="menu-item-name">{t('orders')}</span>
              </div>
            ) : (
              <a href={`${originPath}/shop/orders/?navigation=authentication`} className="menu-row">
                <img src={Icons.orders} className="menu-item-img" alt="" />
                <span className="menu-item-name">{t('orders')}</span>
              </a>
            )}
            <br />
            <div className="menu-row" onClick={handleCustomerSupportClick}>
              <img src={Icons.support} className="menu-item-img" alt="" />
              <span className="menu-item-name">{t('cs')}</span>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </section>
  );
};

export default Header;
